import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';

export default class UploadImageModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.file = null;
    this.uploading = false;
    this.error = null;
  }

  className() {
    return 'MutluresimUploadModal Modal--small';
  }

  title() {
    return 'Resim Yükle';
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Mutluresim-uploadArea">
          <label className="Mutluresim-fileLabel">
            <i className="fas fa-cloud-upload-alt Mutluresim-fileIcon"></i>
            <span className="Mutluresim-fileText">Yüklemek istediğiniz resmi seçin</span>
            <input
              type="file"
              accept="image/*"
              onchange={this.handleFileSelect.bind(this)}
              disabled={this.uploading}
              className="Mutluresim-fileInput"
            />
          </label>
          {this.file && <p className="Mutluresim-fileName">Seçilen dosya: {this.file.name}</p>}
          {this.error && <p className="Mutluresim-error" style={{ color: 'red' }}>{this.error}</p>}
        </div>
        <div className="Modal-footer">
          <Button
            className="Button Button--primary"
            loading={this.uploading}
            disabled={!this.file || this.uploading}
            onclick={this.uploadImage.bind(this)}
          >
            Yükle
          </Button>
        </div>
      </div>
    );
  }

  handleFileSelect(e) {
    const files = e.target.files;
    if (files && files.length > 0) {
      this.file = files[0];
      this.error = null;
    } else {
      this.file = null;
    }
  }

  async uploadImage() {
    if (!this.file) return;

    this.uploading = true;
    this.error = null;
    m.redraw();

    const authToken = app.forum.attribute('happydigital-mutluresim.auth_token');
    
    if (!authToken) {
      this.error = 'API Auth Token ayarlanmamış. Lütfen yönetici ile iletişime geçin.';
      this.uploading = false;
      m.redraw();
      return;
    }

    const formData = new FormData();
    formData.append('source', this.file);

    try {
      const response = await app.request({
        method: 'POST',
        url: app.forum.attribute('apiUrl') + '/mutluresim/upload',
        serialize: (data) => data, // Prevent JSON serialization for FormData
        body: formData,
      });

      if (response.status_code === 200 && response.image && response.image.url) {
        if (this.attrs.onUpload) {
          this.attrs.onUpload(response.image.url);
        }
        app.modal.close();
      } else {
        console.error('Upload error:', response);
        this.error = response.message || (response.success && response.success.message ? response.success.message : 'Yükleme başarısız oldu. Lütfen tekrar deneyin.');
      }
    } catch (err) {
      console.error('Upload exception:', err);
      const errorMessage = err.response && err.response.message ? err.response.message : 'Bir hata oluştu. İnternet bağlantınızı kontrol edip tekrar deneyin.';
      this.error = errorMessage;
    } finally {
      this.uploading = false;
      m.redraw();
    }
  }
}
